import { ArrowForward, Close, Search, SearchOutlined } from "@mui/icons-material";
import { Avatar, Button, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { DateStartInput } from "../widgets/date";
import { Link, useLocation, useNavigate } from "react-router";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { State, StateContext } from "../state";
import { TrackService } from "../client";
import { T } from "../i18n";
import { FlexDivider } from "../widgets/utils";

export const filterFor = (tt: any, textOrGroup: any, isDestination = false) => {
  console.log(textOrGroup)
  if(Array.isArray(textOrGroup)) {
    let res: any = []
      textOrGroup.forEach((text:string) => {
        res.push(filterFor(tt, text, isDestination))
      });
      let resSet:any = [];
      res.forEach((r:any)=> {
        if(resSet.length === 0) {
          resSet = r
        } else {
          let ids = new Set(r.map((e:any) => e.id));
          resSet = resSet.filter((a:any) => !ids.has(a.id)).concat(r);
        }
      });
      return resSet
  }
  let text = textOrGroup;
  if (isDestination) {
    const destination_id = text;
    return tt.filter((t:any) => t.location_id === destination_id)
  }else {
    return tt.filter((t:any) => t.title.toLowerCase().indexOf(text.toLowerCase()) !== -1 || t.description.toLowerCase().indexOf(`${text.toLowerCase()} `) !== -1 || t.location.toLowerCase().indexOf(text.toLowerCase()) !== -1)
  }
}

export const filterForDestinationId = (tt: any, id: any) => {
  return tt.filter((t:any) => t.location_id ? Number(t.location_id) === Number(id) : false)
}

export const SearchBar = ({hideOnScroll}:any) => {

    const { searchString, setSearchString, installedApp, destinations } = useContext(StateContext) as State;
    const [show, setShow] = useState<boolean>(false);
    const [menu, setMenu] = useState<boolean>(false);
    // I tour vengono cercati lato server (autocomplete ritardato, min 3 char).
    // Le destinazioni restano filtrate lato client dalla cache.
    const [tourResults, setTourResults] = useState<any[]>([]);
    const [searching, setSearching] = useState<boolean>(false);
    const searchTimer = useRef<any>(null);

    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
      const q = (searchString || "").trim();
      if (q.length < 3) {
        setTourResults([]);
        setSearching(false);
        return;
      }
      setSearching(true);
      searchTimer.current = setTimeout(() => {
        TrackService.search(q)
          .then((res: any) => { setTourResults(res || []); setSearching(false); })
          .catch(() => { setTourResults([]); setSearching(false); });
      }, 350);
      return () => { if (searchTimer.current) clearTimeout(searchTimer.current); };
    }, [searchString]);

    const _setMenu = (b: boolean) => {
      if(hideOnScroll) {
        window.scrollTo({top: window.innerWidth <= 600 ? 20 : 100, left: 0})
      }
      setMenu(b)
    }

    const searchOnPressEnter = (event: any) => {
      if (event.key === 'Enter') {
        doSearch()
      }
    }

    const doSearch = () => {
      navigate(`list?q=${encodeURIComponent(searchString)}`)
    }

    const renderDropDown = () => {
      let _tours = tourResults
      let _destinations = searchString
        ? destinations.filter((d: any) => d.count > 0 && d.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1)
        : []
      let _allDestinations = destinations.filter((d: any) => d.count > 0)
      let menuClass = menu ? "searchbar-menu visible": "searchbar-menu"
      if(hideOnScroll) {
        menuClass += " search-hide-on-scroll";
      }
      return (
        <List sx={{ bgcolor: 'background.paper' }} className={menuClass}>
          <div>
          {!searchString &&
          <>
            {/* <ListItem style={{ padding: "0 22px", paddingTop: 11}}>
              <Typography variant="h6">Ecco le località dove siamo presenti</Typography>
            </ListItem> */}
            {_allDestinations.map((d: any, index: number) => (
              <Fragment key={`all-dest-${d.id}`}>
              <ListItem className="searchbar-destination" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                navigate(`/list?destination=${d.id}&dN=${d.name}`)
              }}>
                <ListItemAvatar>
                  <Avatar src={d.photo} alt="" sx={{borderRadius: "16px", width: "130px", height: "70px", marginRight: 2}}/>
                </ListItemAvatar>
                <ListItemText
                    primary={d.name}
                    secondary={T('tours_in_destination', {count: d.count})}
                />
              </ListItem>
              {index < _allDestinations.length - 1 &&
                <Divider variant="inset" component="li" sx={{ marginLeft: "16px", marginRight: "16px" }}/>
              }
              </Fragment>
            ))}
          </>}
          {searchString &&
            <>
              {_destinations.length > 0 &&
                <div className="searchbar-subtitle">{T('Destinazioni')}</div>
              }
              {_destinations.map((d: any, index: number) => (
                <Fragment key={`dest-${d.id}`}>
                <ListItem className="searchbar-destination" onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  navigate(`/list?destination=${d.id}&dN=${d.name}`)
                }}>
                  <ListItemAvatar>
                    <Avatar src={d.photo} alt="" sx={{borderRadius: "16px", width: "130px", height: "70px", marginRight: 2}}/>
                  </ListItemAvatar>
                  <ListItemText
                    primary={d.name}
                    secondary={T('tours_in_destination', {count: d.count})}
                  />
                </ListItem>
                {index < _destinations.length - 1 &&
                  <Divider variant="inset" component="li" sx={{ marginLeft: "16px", marginRight: "16px" }}/>
                }
                </Fragment>
              ))}
              {_tours.length > 0 &&
                <div className="searchbar-subtitle">{T('Tour')}</div>
              }
              {_tours.map((t:any, index: number) => (
                <Fragment key={`tour-${t.id}`}>
                <Link className="no-link click" to={`tour/${t.id}`} target={installedApp ? undefined : "_blank"} rel="noopener noreferrer">
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <Avatar src={t.image} style={{borderRadius: 8}} />
                      </ListItemAvatar>
                      <ListItemText
                        style={{width: '200px'}}
                        primary={t.title}
                        secondary={t.location}
                      />
                  </ListItem>
                </Link>
                {index < _tours.length - 1 &&
                    <Divider variant="inset" component="li" sx={{ marginLeft: "16px", marginRight: "16px" }}/>
                }
                </Fragment>
              ))}
              {searching && _tours.length === 0 &&
                <ListItem><ListItemText primary={`${T('search')}…`} /></ListItem>
              }
              {!searching && _destinations.length === 0 && _tours.length === 0 &&
                <ListItem><ListItemText primary={`${T('no_results_for')} "${searchString}"`} /></ListItem>
              }
            </>
          }
          </div>
          {searchString && 
            <div className="searchbar-footer" onClick={doSearch}>
              <Typography variant="h6">{T('see_all_results')} <i style={{fontWeight: "normal"}}>"{searchString}"</i></Typography>
              <FlexDivider/>
              <ArrowForward/>
            </div>
          }
        </List>
      )
    }

    const hideXs = hideOnScroll ? "block" : (show ? "block": "none");
    const mainClass = pathname === "/" ? "searchbar-main" : "searchbar-main force-visible"
    const mobile = window.innerWidth <= 600;

    return (
      <div className={mainClass}>
        <div className={`searchbar-container ${show && 'searchbar-mobile'}`}>
            <Grid sx={{ display: {xs: hideXs, sm: "block"}}}>
              <div className="searchbar">
                <div className="row" style={{ position: "relative"}} onFocus={() => _setMenu(true)} onBlur={() => setTimeout(() => setMenu(false), 200)}>
                  {show || menu ?
                    <Close onClick={() => {setShow(false); setSearchString("")}}/>
                    :  
                    !mobile && <SearchOutlined className="no-event"/>
                  }
                  <input 
                    className={(!hideOnScroll || (mobile && (show || menu))) ? 'indent': ''}
                    onKeyDown={searchOnPressEnter} 
                    placeholder={T('search_placeholder')} 
                    value={searchString} 
                    onChange={(e) => setSearchString(e.target.value)}
                  />
                  {renderDropDown()}
                </div>
                {!show && !mobile &&
                  <DateStartInput />
                }
                <Button variant="contained" className="search-btn" onClick={doSearch}>{T('search')}</Button>
              </div>
            </Grid>
        </div>
        {!hideOnScroll && 
          <Grid sx={{ display: {xs: "block", sm: "none"}}}>
            <div className="row">
              <div className="btn-icon" onClick={() => setShow(!show)}>
                <Search />
              </div>
            </div>
          </Grid>
        }
      </div>
    )
  }